import { render, staticRenderFns } from "./PFSettlementList.vue?vue&type=template&id=1d4f44ab"
import script from "./PFSettlementList.vue?vue&type=script&lang=js"
export * from "./PFSettlementList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports